import { render, staticRenderFns } from "./text-barsr3.vue?vue&type=template&id=9b5ffa4a&scoped=true&"
var script = {}
import style0 from "./text-barsr3.vue?vue&type=style&index=0&id=9b5ffa4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b5ffa4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b5ffa4a')) {
      api.createRecord('9b5ffa4a', component.options)
    } else {
      api.reload('9b5ffa4a', component.options)
    }
    module.hot.accept("./text-barsr3.vue?vue&type=template&id=9b5ffa4a&scoped=true&", function () {
      api.rerender('9b5ffa4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/other/cssfx/components/text-barsr3.vue"
export default component.exports